import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0935a720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Aircraft Types", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Click card for the maintenance training.", -1))
const _hoisted_4 = { class: "card-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "photo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-content" }
const _hoisted_9 = ["innerHTML"]

import { computed } from "vue";
import { useStore } from "@/store";
import { useRouter, RouterLink } from "vue-router";

import Boeing737_800NG from "@/assets/Boeing737-800NG.png";
import Boeing737MAX from "@/assets/Boeing737-max.png";
import Airbus321Neo from "@/assets/Airbus321Neo.png";
import OtherPlane from "@/assets/other.jpg";


export default /*#__PURE__*/_defineComponent({
  __name: 'AircraftsPage',
  setup(__props) {

const router = useRouter();

const aircrafts = computed(() => {
  return [
    {
      id: "B737-800",
      name: "Boeing 737-800NG",
      picture: Boeing737_800NG,
      description: "Training and Education",
    },
    {
      id: "B737-MAX",
      name: "Boeing 737-MAX",
      picture: Boeing737MAX,
      description: "Training and Education",
    },
    {
      id: "",
      name: "Airbus 321 Neo",
      picture: Airbus321Neo,
      description: "Training and Education",
      descriptions: "We are preparing two engine types(LEAP-1A, PW1100G) Will be uploaded by Dec. 2023.",
    },
    {
      id: "",
      name: "",
      picture: OtherPlane,
      description: "",
      descriptions: "We are preparing content for different aircraft types of aircraft maintenance training. You can expect to see content on new aircraft types soon",
    },
  ]
});

const gotoRoute = (path: string) => {
  if (path === "") return;
  router.push(`/aircraft/${path}`);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("section", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aircrafts.value, (aircraft) => {
        return (_openBlock(), _createElementBlock("article", {
          class: "card",
          key: aircraft.id
        }, [
          _createElementVNode("div", {
            onClick: () => gotoRoute(aircraft.id)
          }, [
            _createElementVNode("picture", _hoisted_6, [
              _createElementVNode("img", {
                src: aircraft.picture
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", null, _toDisplayString(aircraft.name), 1),
              _createElementVNode("p", null, _toDisplayString(aircraft.description), 1),
              _createElementVNode("span", {
                innerHTML: aircraft.descriptions
              }, null, 8, _hoisted_9)
            ])
          ], 8, _hoisted_5)
        ]))
      }), 128))
    ])
  ]))
}
}

})